import { useAdminResourceCheckStore } from '~~/layers/crane-manager/admin-stores/adminResourceCheck.store'

/**
 * Clears the Crane Manager resource-check cache on logout.
 *
 * Lives in this layer (not `layers/base`) so Capacitor — which does not extend
 * crane-manager — never resolves the admin store module. Store is created only
 * on the logout transition so ordinary visitors never instantiate it.
 */
export default defineNuxtPlugin(() => {
    const { isLoggedIn, isSessionPending } = useBetterAuth()

    watch([isLoggedIn, isSessionPending], ([loggedIn, pending], previous) => {
        if (pending) {
            return
        }
        const wasLoggedIn = previous?.[0]
        if (!loggedIn && wasLoggedIn) {
            useAdminResourceCheckStore().clearCheckCache()
        }
    })
})
